import 'owl.carousel';

const removeAnimationClass = $itemsToAnimate => {
  $itemsToAnimate.removeClass((index, className) => (className.match(/(^|\s)animate__\S+/g) || []).join(' '))
};

const addAnimationClass = $itemsToAnimate => {
  $itemsToAnimate.each((i, e) => {
    const $e = $(e);
    const animation = $e.data('animation') || 'fadeIn';

    $e.addClass(`animate__animated animate__${animation}`)
  });
};

export default () => {
  const $heroHeaderCarousels = $('.ag-hero-header__carousel');
  if (!$heroHeaderCarousels.length) {
    return;
  }

  $heroHeaderCarousels.each((i, e) => {
    const $carousel = $(e);
    let $carouselItems = $();

    $carousel.on('initialized.owl.carousel', e => {
      $carouselItems = $carousel.find('.owl-item');
      const $item = $carouselItems.eq(e.item.index);
      addAnimationClass($item.find('[data-animation]'));
    });

    $carousel.on('change.owl.carousel', e => {
      const $item = $carouselItems.eq(e.item.index);
      const $toAnimate = $item.find('[data-animation]');
      removeAnimationClass($toAnimate);
    });

    $carousel.on('changed.owl.carousel', e => {
      $carousel.trigger('stop.owl.autoplay');
      $carousel.trigger('play.owl.autoplay');

      const $item = $carouselItems.eq(e.item.index);
      addAnimationClass($item.find('[data-animation]'));
    });

    $carousel.owlCarousel({
      items: 1,
      autoplay: true,
      loop: true,
    });
  });
};
